var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowBall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97.339,
    height: 97.339,
    viewBox: "0 0 97.339 97.339",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5548",
    "data-name": "Group 5548",
    transform: "translate(-1104 -1993)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_25",
    "data-name": "Ellipse 25",
    cx: 48.669,
    cy: 48.669,
    r: 48.669,
    transform: "translate(1104 1993)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "increase-up-profit-icon",
    transform: "translate(1126.004 2026.994)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_448",
    "data-name": "Path 448",
    d: "M.866,24.189a2.872,2.872,0,1,0,4.005,4.116L16.7,16.76,26.6,26.307a2.872,2.872,0,0,0,4.061-.077L46.819,9.875v8.246a2.88,2.88,0,0,0,5.76,0V2.875H52.57A2.866,2.866,0,0,0,49.519.012H35.257a2.88,2.88,0,1,0,0,5.76H42.8L28.539,20.2l-9.855-9.512a2.868,2.868,0,0,0-3.992.013L.866,24.189Z",
    transform: "translate(0 0)",
    fill: "#ff5d00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBall);
export default __webpack_public_path__ + "static/media/arrow-ball.b4025a7abf9b25b990130a506ff87f59.svg";
export { ForwardRef as ReactComponent };